let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7rzCK")).then(() => parcelRequire('3Eb0P'));